import { useLiveEvents } from '@/lib/live';
import { openRecord } from '@/lib/overlays';
import { routeStore } from '@/lib/router';
import { toast } from '@/lib/toast';
import { actions } from '@/lib/actions';

/** Tells you when one of your searches, or a look-up of a company's key people, finishes or stops, with a way to open it. */
export function FinderLive() {
  useLiveEvents((e) => {
    if (e.type !== 'notification') return;
    const n = e.notification;
    if (n.kind !== 'ai_done' || !n.entityId) return;
    const id = n.entityId;
    const { route } = routeStore.get();
    if (n.entityType === 'company') {
      const showing = route.record?.type === 'company' && route.record.id === id && !route.admin;
      // The company in view shows the people as they arrive.
      if (showing) return;
      toast(`${n.lead} · ${n.title}`, { icon: 'sparkle', action: { label: 'Open', run: () => openRecord('company', id) } });
      return;
    }
    if (n.entityType !== 'finder') return;
    const showing = route.view === 'finder' && route.params.s === id && !route.record && !route.admin;
    toast(`${n.lead} · ${n.body ?? n.title}`, {
      icon: 'sparkle',
      action: showing ? undefined : { label: 'Open', run: () => actions.openFinder(id) },
    });
  });
  return null;
}
